import React, { FC } from 'react'

import { TableCell, TableHead, TableRow } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'

type Props = {
  className?: string
}

export const ApprovalRequestTableHead: FC<Props> = ({ className }) => {
  return (
    <TableHead className={className}>
      <TableRow align="left" className="tw-h-[2.36rem]">
        <TableCell as="th" className="tw-w-[5%]">
          <Txt
            sizeType="s"
            className="tw-text-standardText-secondary tw-px-s-1 tw-text-nowrap tw-font-normal"
          >
            申請No
          </Txt>
        </TableCell>
        <TableCell as="th">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            プロジェクト
          </Txt>
        </TableCell>
        <TableCell as="th" className="tw-w-[13%]">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            申請種別
          </Txt>
        </TableCell>
        <TableCell as="th" className="tw-w-[13%]">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            タイトル
          </Txt>
        </TableCell>
        <TableCell as="th" className="tw-w-[11%]">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            申請者
          </Txt>
        </TableCell>
        <TableCell as="th" className="tw-w-[9%]">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            申請日時
          </Txt>
        </TableCell>
        <TableCell as="th" className="tw-w-[9%]">
          <Txt sizeType="s" className="tw-text-standardText-secondary tw-px-s-1 tw-font-normal">
            承認期限
          </Txt>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}
